import { Notification, Typography } from '@smartgift/frontend-toolkit';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useValidationErrorsStore } from '@hero/components/providers/ValidationErrorsProvider';

const CollectionsWarningList = styled.ul`
  padding: 0 16px;
`;

const CollectionsWarningListItem = styled.li`
  list-style-type: disc;

  ${Typography.S.Typography} {
    text-transform: lowercase;
  }

  ${Typography.S.Typography}:first-letter {
    text-transform: uppercase;
  }
`;

function ModalValidationErrors({ style }) {
  const { t } = useTranslation();

  const { modalCounter, modalErrors } = useValidationErrorsStore();

  const validationErrors = modalErrors || {};
  const isOnlyOneError =
    Object.keys(validationErrors)?.length === 1 &&
    validationErrors?.[Object.keys(validationErrors)?.[0]]?.length === 1;

  useEffect(() => {
    if (Object.keys(validationErrors)?.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, [validationErrors, modalCounter]);

  if (isOnlyOneError) {
    return (
      <Notification
        style={style}
        key={JSON.stringify({ modalCounter, modalErrors })}
        className={Object.values(modalErrors)?.length ? 'element-vibration' : ''}
        status={Object.keys(validationErrors)?.[0]}
        content={
          <Typography variant="body2" emphasis="weak">
            <span>{validationErrors?.[Object.keys(validationErrors)?.[0]]?.[0]}</span>
          </Typography>
        }
      />
    );
  }

  return Object.keys(validationErrors)?.map(status => {
    return (
      <Notification
        style={style}
        status="warning"
        key={JSON.stringify({ status, modalCounter, modalErrors })}
        className={Object.values(modalErrors)?.length ? 'element-vibration' : ''}
        content={
          <>
            <Typography variant="body2" emphasis="weak">
              {t('toContinuePlease')};
            </Typography>
            <CollectionsWarningList>
              {validationErrors[status]?.map((pageError, pageErrorIndex) => {
                return (
                  <CollectionsWarningListItem key={pageErrorIndex.toString()}>
                    <Typography variant="caption1" emphasis="weak">
                      {pageError}
                    </Typography>
                  </CollectionsWarningListItem>
                );
              })}
            </CollectionsWarningList>
          </>
        }
      />
    );
  });
}

export { ModalValidationErrors };
